module.exports = __webpack_public_path__ + "media/sonification-note-01.f8a7e993.wav";